export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--D.69a56ac2.png";